export const SUBMIT_SYNC_CATEGORIES = {
  REQUEST: "SUBMIT_SYNC_CATEGORIES_REQUEST",
  SUCCESS: "SUBMIT_SYNC_CATEGORIES_SUCCESS",
  FAILURE: "SUBMIT_SYNC_CATEGORIES_FAILURE",
};

export const FETCH_SYNC_JOB_DETAILS = {
  REQUEST: "FETCH_SYNC_JOB_DETAILS_REQUEST",
  SUCCESS: "FETCH_SYNC_JOB_DETAILS_SUCCESS",
  FAILURE: "FETCH_SYNC_JOB_DETAILS_FAILURE",
};

export const CLEAR_SYNC_JOB_STATE = "CLEAR_SYNC_JOB_STATE";

export const FETCH_CATEGORY_LATEST_SYNC = {
  REQUEST: "FETCH_CATEGORY_LATEST_SYNC_REQUEST",
  SUCCESS: "FETCH_CATEGORY_LATEST_SYNC_SUCCESS",
  FAILURE: "FETCH_CATEGORY_LATEST_SYNC_FAILURE",
};

export const SYNC_CATEGORIES_SERVICE_URL = "LOAD_SYNC_CATEGORIES_SERVICE_URL";

export const LATEST_SYNC_JOB_NOT_FOUND = "LatestSyncJobNotFound";

export const RESET_SYNC_CATEGORY_DETAILS = "RESET_SYNC_CATEGORY_DETAILS";

export interface SyncCategoriesRequestPayload {
  source: {
    storeId: string | null;
    catalogId: string;
    categoryId: string;
    localeCode: string | null;
  };
  targets: {
    storeId: string;
    catalogId: string;
    categoryId: string;
  }[];
  options: {
    addProducts: boolean;
    removeProducts: boolean;
  };
  triggeredBy: string;
}

export interface SyncJobDetailsRequestPayload {
  syncJobId: string;
}

export interface SyncJobDetails {
  syncJobId: string;
  source: {
    storeId: string;
    catalogId: string;
    categoryId: string;
  };
  targets: {
    storeId: string;
    catalogId: string;
    categoryId: string;
    status: string;
    statusAt: string;
    error: {
      reason?: string;
      message?: string;
      Cause?: string;
      Error?: string;
    };
    createdAt: string;
    updatedAt: string;
  }[];
  options: {
    addProducts: boolean;
    removeProducts: boolean;
  };
  status: string;
  statusAt: string;
  error: {
    reason?: string;
    message?: string;
    Cause?: string;
    Error?: string;
  };
  triggeredBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface FetchCategoryLatestsSyncPayload {
  catalogId: string;
  categoryId: string;
}

export interface CategoryLatestSync {
  syncJobId: string;
  source: {
    storeId: string;
    catalogId: string;
    categoryId: string;
  };
  targets: {
    storeId: string;
    catalogId: string;
    categoryId: string;
    status: string;
    statusAt: string;
    error: {
      reason: string;
      message: string;
    };
    createdAt: string;
    updatedAt: string;
  }[];
  options: {
    addProducts: boolean;
    removeProducts: boolean;
  };
  status: string;
  statusAt: string;
  error: {
    reason: string;
    message: string;
  };
  triggeredBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface SyncCategoriesRequestAction {
  type: typeof SUBMIT_SYNC_CATEGORIES.REQUEST;
  payload: SyncCategoriesRequestPayload;
}

export interface SyncJobDetailsRequestAction {
  type: typeof FETCH_SYNC_JOB_DETAILS.REQUEST;
  payload: SyncJobDetailsRequestPayload;
}

export interface FetchCategoryLatestsSyncAction {
  type: typeof FETCH_CATEGORY_LATEST_SYNC.REQUEST;
  payload: FetchCategoryLatestsSyncPayload;
}
